module.exports = __webpack_public_path__ + "img/05.6807de5d.png";